import React from 'react';
import ReactModal from 'react-modal';
import { Global } from '@emotion/react';
import {
  Overlay,
  Container,
  ScrollContainer,
  Dialog,
  Content,
  Headline,
  CloseIconWrapper,
  CloseIconButton,
  content,
  overlay,
} from './Modal.styles';

export type ModalParams = {
  isOpen: boolean;
  onRequestClose: () => void;
  headline?: string;
  ariaLabel?: string;
  children: any;
};

const preventBgClose = (event: React.MouseEvent): void => {
  event.stopPropagation();
};

/**
 * Basically a wrapper around ReactModal to add specific default styling and settings.
 * @param props All props that are supported by ReactModal
 */
const Modal = ({
  isOpen,
  onRequestClose,
  headline,
  ariaLabel,
  children,
  ...props
}: ModalParams): React.ReactElement => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    shouldCloseOnOverlayClick
    style={{ overlay, content }}
    contentLabel={ariaLabel}
    bodyOpenClassName="noScroll"
    ariaHideApp={process.env.NODE_ENV !== 'test'}
    {...props}
  >
    <Global
      styles={{
        'body.noScroll': {
          overflow: 'hidden',
        },
      }}
    />
    <Overlay onClick={onRequestClose}>
      <Container className="container">
        <div className="row">
          <div className="col">
            <Dialog onClick={preventBgClose}>
              <CloseIconWrapper>
                <CloseIconButton onClick={onRequestClose}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 24">
                    <path
                      fill="#FFF"
                      fillRule="evenodd"
                      // eslint-disable-next-line max-len
                      d="M24.328 3.409L22.565 1.646 13 11.238 3.393 1.646 1.63 3.409 11.238 13 1.63 22.566 3.393 24.329 13 14.762 22.565 24.329 24.328 22.566 14.762 13z"
                      transform="translate(-276 -849) translate(10 840) translate(257) translate(9 9)"
                    />
                  </svg>
                </CloseIconButton>
              </CloseIconWrapper>
              <Headline>{headline}</Headline>
              <ScrollContainer className="lb-outline" tabIndex={0}>
                <Content>
                  {children}
                </Content>
              </ScrollContainer>
            </Dialog>
          </div>
        </div>
      </Container>
    </Overlay>
  </ReactModal>
);

if (process.env.NODE_ENV !== 'test') {
  ReactModal.setAppElement('body');
}

export default Modal;
